import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWave2 = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={900} height={600} {...props}>
        <path
            fill="#EE486F"
            d="m0 112 21.5 4.3c21.5 4.4 64.5 13 107.3 28.7 42.9 15.7 85.5 38.3 128.4 45.7 42.8 7.3 85.8-.7 128.6-13.9 42.9-13.1 85.5-31.5 128.4-27.5 42.8 4 85.8 30.4 128.6 29 42.9-1.3 85.5-30.3 128.4-42.8C814 123 857 127 878.5 129l21.5 2V0H0Z"
        />
    </svg>
);
export default SvgWave2;
